export default __webpack_public_path__ + "static/media/profile-photo.ea07b1d6.jpg";